var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/save"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.56 4.837H6.026A2.447 2.447 0 0 0 3.58 7.284v2.379M17.27 9l-6.984 7-3.483-3.5M6.146 21h11.708A3.146 3.146 0 0 0 21 17.854V6.146A3.146 3.146 0 0 0 17.854 3h-4.18a2.04 2.04 0 0 0-1.871 1.248c-.561 1.316-1.453 3.307-2.026 4.09H6.146A3.146 3.146 0 0 0 3 11.482v6.371A3.146 3.146 0 0 0 6.146 21Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.15273932b918d49e816e5bab0ce18aca.svg";
export { ForwardRef as ReactComponent };